import { env } from '@constants/env';

export const AUTH_SERVICES_BASE_URL = env.authServicesBaseUrl;

export const COMPANY_GROUPS_API_URL = `${AUTH_SERVICES_BASE_URL}/api/v1/companyGroups`;

/** A client id is appended: `${APPS_API_URL}/${cid}`. */
export const APPS_API_URL = `${AUTH_SERVICES_BASE_URL}/api/v1/apps`;

/** A client id is appended: `${USERS_API_URL}/${cid}`. */
export const USERS_API_URL = `${AUTH_SERVICES_BASE_URL}/api/v1/users`;

/**
 * PUT target for a permission an app holds outright, rather than over a given
 * object. Both parts are path segments, so both are encoded.
 */
export const appPermissionUrl = (cid: string, permission: string): string =>
	`${APPS_API_URL}/${encodeURIComponent(cid)}/permissions/${encodeURIComponent(permission)}`;

export const PRINCIPALS_API_URL = `${AUTH_SERVICES_BASE_URL}/api/v1/principals`;
